import get from 'lodash/get';
import map from 'lodash/map';
import flatten from 'lodash/flatten';
import some from 'lodash/some';
import { createSelector } from 'reselect';

export const getProductDetails = (state) => state.productDetails || {};
const getSelectedStore = (state) => state.selectedStore;
const getFeatureFlags = (state) => (state.context && state.context.featureFlags) || {};
const getLocationServiceStore = (state) => state.locationServiceReducer || {};

const getFirstProduct = createSelector([getProductDetails], (productDetails) =>
    get(productDetails, 'products[0].product', '')
);

export const isPromotionalBundle = createSelector([getProductDetails], (productDetails) =>
    get(productDetails, 'bundleIds.length', false)
);

export const hasProtectionPlan = createSelector([getProductDetails], (productDetails) => {
    const lots = flatten(map(productDetails.products, 'product.lots'));
    return some(lots, 'warranties.length');
});

export const isBundleProduct = createSelector(
    [getProductDetails],
    (productDetails) => productDetails.type === 'BUNDLE'
);

export const getStoreID = createSelector(
    [getSelectedStore, getFeatureFlags, getLocationServiceStore],
    (locationServiceStore) => {
        const storeID = (locationServiceStore && locationServiceStore.storeId) || '';
        return storeID;
    }
);

export const isFpacForBundle = createSelector(
    [getFeatureFlags, getProductDetails],
    (featureFlags, productDetails) =>
        get(featureFlags, 'fpacForBundle', true) && !get(productDetails, 'bundleIds.length', false)
);

export default getFirstProduct;
